(async function () {
	async function removeRequest(id) {
		const removeRequest = {
			method: "POST",
			headers: {
				"Content-Type": "application/json;",
				Accept: "application/json",
			},
			body: JSON.stringify({
				id: String(id),
				quantity: 0,
			}),
		};
		const response = await fetch("/cart/change.js", removeRequest);
		return response;
	}

	async function removeKpsp() {
		const cart = await fetch("/cart.js");
		const cartResponse = await cart.json();

		const removalPromises = cartResponse.items
			.filter((item) => item.handle.includes("navidium"))
			.map((item) => removeRequest(item.id));

		const results = await Promise.all(removalPromises);
		if (results.some((response) => response.ok)) {
			localStorage.removeItem("nvdProtectionPrice");
			localStorage.removeItem("nvdVariant");
			localStorage.setItem("nvd_opted_out", true);
			if (window.Alpine) {
				window.dispatchEvent(new CustomEvent("reloadCart"));
			} else {
				document.addEventListener("alpine:init", () => {
					window.dispatchEvent(new CustomEvent("reloadCart"));
				});
			}
		}
	}

	await removeKpsp();
})();
